module.exports = __webpack_public_path__ + "img/memberThree.5318c993.svg";